/** The carrier page's tabs, in order: the corporate setup tabs from `Account/CarrierAccount`. The first is the default. */
export const TABS = [
    { value: 'company-info', label: 'Company Info' },
    { value: 'integrations', label: 'Integrations' },
    { value: 'insurance-contracts', label: 'Insurance & Contracts' },
    { value: 'coverage-capacity', label: 'Coverage + Capacity' },
    { value: 'tariff-links', label: 'Tariff Links' },
];
